import React, {useReducer, useState} from 'react'
import {Box, Tooltip, Typography} from '@material-ui/core';
import GridBlock from 'components/GridBlock';
import TextInput from 'components/TextInput';
import Tr from 'translations/Translations';
import clsx from 'clsx';
import InputLimits from 'constants/InputLimits';
import WorkableIconDeleteButton from 'components/button/WorkableIconDeleteButton';
import WorkableIconExpandButton from "components/button/WorkableIconExpandButton";
import WorkableIconConfirmButton from "components/button/WorkableIconConfirmButton";
import {makeStyles} from "@material-ui/styles";
import Form from "components/Form";
import VS from 'constants/ValidationShema';
import {connect} from "react-redux";
import PurchasingGroupStage1Service from "services/PurchasingGroupStage1Service";
import iconWorksReducer from "libs/iconWorksReducer";
import {confirmComplex, simpleConfirm} from "libs/ConfirmNotification";
import IconButton from "components/button/IconButton";
import ClearIcon from "@material-ui/icons/Clear";
import WarningIcon from "@material-ui/icons/Warning";
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import RestoreIcon from '@material-ui/icons/Restore';
import WorkableButton from "components/button/WorkableButton";
import PurchasingGroupSectionService from "services/PurchasingGroupSectionService";
import {PurchasingGroupStageSections} from "../../../../constants/PurchasingGroupStageSections";
import WorkableIconMailButton from "components/button/WorkableIconMailButton";
import useSnackbar from "hooks/useSnackbar";
import WorkableIconEditButton from "../../../../../../../../components/button/WorkableIconEditButton";

const limits = InputLimits.procedure.organization;

const useStyle = makeStyles(theme => ({
    root: {
        '&>*:nth-child(2)': {
            flexGrow: 1,
        }
    },
    rootEdit: {
        '&>*:nth-child(2)': {
            flexGrow: 1,
            paddingLeft: theme.spacing(2),
        }
    },
    editInput: {},
    marginLeft: {
        marginLeft: theme.spacing(2),
    },
    title: {
        marginLeft: theme.spacing()
    },
    rotate: {
        transform: 'rotate(180deg)'
    },
    cursorPointer: {
        cursor: 'pointer'
    },
    buttonReject: {
        marginTop: theme.spacing()
    },
    rejected: {
        color: theme.palette.text.disabled
    }
}))

function MembersElementTitle(
    {
        groupId,
        index,
        member,
        open,
        onOpen,
        editable,
        coordinatorView,
        validationSection,
        formSubmit
    }) {

    const classes = useStyle();
    const formId = 'memberTitleElement_' + member.identity
    const [editName, setEditName] = useState(false)
    const rejected = member.rejectionDate !== null;
    const canReject = member.actions['reject'] != null;
    const canRestore = member.actions['restore'] != null;
    const {enqueueSuccessSnackbar} = useSnackbar();

    const [iconWorks, dispatchIconWorks] = useReducer(iconWorksReducer, {
        anyWorks: false,
        name: false,
        delete: false,
        reject: false,
        restore: false,
        resend: false
    });


    const handleEdit = () => {
        if (editName) {
            formSubmit[formId]()
        } else {
            setEditName(true)
        }
    }

    const submitName = (values) => {
        dispatchIconWorks({type: 'name', works: true});
        PurchasingGroupStage1Service.updateMemberName(groupId, member.identity, values).then(() => setEditName(false)).finally(() => dispatchIconWorks({
                type: 'name',
                works: false
            })
        );
    }

    const doDelete = () => {
        dispatchIconWorks({type: 'delete', works: true});
        PurchasingGroupStage1Service.deleteMember(groupId, member.identity).then(() => {
            PurchasingGroupSectionService.getSections(groupId, PurchasingGroupStageSections.MEMBERS)
        }).catch(() => dispatchIconWorks({type: 'delete', works: false}))
    }

    const onReject = () => {
        setEditName(false);
        dispatchIconWorks({type: 'reject', works: true});
        PurchasingGroupStage1Service.rejectMember(groupId, member.identity).finally(() => dispatchIconWorks({type: 'reject', works: false}))
    }

    const onRestore = () => {
        dispatchIconWorks({type: 'restore', works: true});
        PurchasingGroupStage1Service.restoreMember(groupId, member.identity).finally(() => dispatchIconWorks({type: 'restore', works: false}))
    }


    const showTitleComponent = () => (
        <Typography
            variant='body1'
            className={clsx(classes.cursorPointer, classes.title)}
            onClick={onOpen}
        >
            <Box
                component='span'
                fontWeight='fontWeightBold'

            >
                {member.name}
            </Box>
        </Typography>
    )


    const editNameComponent = () => (
        <Form
            id={formId}
            initialValues={{
                name: member.name
            }}
            validationSchema={VS.object({
                name: VS.stringMax(limits.NAME)
            })
            }
            onSubmit={submitName}>
            {(formikProps) => (
                <TextInput
                    limit={limits.NAME}
                    className={classes.editInput}
                    label={Tr('name')}
                    id='name'
                    formikProps={formikProps}
                />
            )}
        </Form>
    )


    const onResend = () => {
        dispatchIconWorks({type: 'resend', works: true});
        PurchasingGroupStage1Service.resendInviteNotification(groupId, member.identity).then(() => enqueueSuccessSnackbar(Tr('purchase_group_member_resend_success'))).finally(() => dispatchIconWorks({type: 'resend', works: false}))
    }


    return (
        <GridBlock
            alignItems='center'
            className={clsx({
                [classes.root]: !editName,
                [classes.rootEdit]: editName,
                [classes.rejected]: rejected
            })}
            wrap='nowrap'
        >
            {!coordinatorView ? <GridBlock wrap='nowrap'>
                <Typography
                    variant='body1'
                    className={classes.title}
                >
                    {index + 1}.
                </Typography>
                {!rejected && !member.complete && <Tooltip className={classes.title} title={Tr('complete_missing_data')} placement="top">
                    <WarningIcon className={classes.cursorPointer} onClick={onOpen} color='error'/>
                </Tooltip>}
            </GridBlock> : <Typography> </Typography>
            }

            {editName ? editNameComponent() : showTitleComponent()}

            <GridBlock wrap='nowrap'>
                {!coordinatorView && <>
                    {editName ? <>
                            <WorkableIconConfirmButton
                                onClick={handleEdit}
                                color='primary'
                                working={iconWorks.name}
                                disabled={iconWorks.anyWorks}
                            />
                            <IconButton
                                onClick={() => setEditName(false)}
                                tooltip={Tr('cancel')}
                                Icon={ClearIcon}
                                disabled={iconWorks.anyWorks}
                            />
                        </> :
                        <WorkableIconEditButton
                            onClick={handleEdit}
                            color='primary'
                            disabled={!editable || rejected || member.primary || iconWorks.anyWorks}
                        />
                    }
                    <WorkableIconDeleteButton
                        color='primary'
                        onClick={() => confirmComplex({
                            onConfirm: doDelete,
                            confirmText: Tr('confirm_delete'),
                            confirmText2: member.name,
                            translateConfirmTexts: false
                        })}
                        working={iconWorks.delete}
                        disabled={!editable || !member.actions['delete'] || iconWorks.anyWorks}
                    />
                    {
                        canReject ?
                            <WorkableButton
                                className={classes.buttonReject}
                                working={iconWorks.reject}
                                disabled={!editable || iconWorks.reject}
                                variant="text"
                                Icon={HighlightOffIcon}
                                onClick={() => simpleConfirm("purchase_groups_exclude_confirm", onReject)}>{Tr('purchase_groups_exclude')}
                            </WorkableButton>
                            : (canRestore &&
                                <WorkableButton
                                    className={classes.buttonReject}
                                    working={iconWorks.restore}
                                    disabled={!editable || iconWorks.restore}
                                    variant="text" Icon={RestoreIcon}
                                    onClick={() => simpleConfirm("purchase_groups_restore_confirm", onRestore)}>{Tr('purchase_groups_restore')}
                                </WorkableButton>
                            )
                    }
                </>}

                {!coordinatorView && editable && validationSection.activeStage === 1 &&
                    <WorkableIconMailButton disabled={iconWorks.anyWorks} tooltip={Tr('purchase_group_member_resend')} onClick={onResend}
                                            working={iconWorks.resend} color='primary'/>}

                {!coordinatorView && <WorkableIconExpandButton
                    color='primary'
                    onClick={onOpen}
                    expanded={open}
                    disabled={iconWorks.delete}
                />}
            </GridBlock>
        </GridBlock>
    )
}

MembersElementTitle.propTypes = {}

export default connect((state) => ({
    formSubmit: state.form
}), {})(MembersElementTitle);